<template>
  <div class="p-4">
    <div class="mb-4">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none" style="cursor: pointer;" @click="goBack()">
        <path d="M38.75 19.0003H1.25M1.25 19.0003L18.9583 1.29199M1.25 19.0003L18.9583 36.7087" stroke="#FF7C48" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </div>

    <h1 class="title">
      <span v-if="surveyTemplate"> {{ surveyTemplate.name | translate }}</span>
    </h1>

    <div class="text-right">
      <div class="d-flex justify-content-end align-items-end">
        <div class="new-task-text mb-2 ml-2">
          <span @click="createSurvey">{{ $t("asset-group-survey.create") }}</span>
        </div>
        <div @click="createSurvey" class="plus-button "></div>
        <!-- <b-button variant="primary" @click="createSurvey"></b-button> -->
      </div>
    </div>

    <nav class="tab-menu">
      <div :class="{ active: activeTab === 'IN_PROGRESS' }" @click="activeTab = 'IN_PROGRESS'">
        {{ $t("asset-group-survey.in-progress") }}
      </div>
      <div :class="{ active: activeTab === 'ARCHIVE' }" @click="activeTab = 'ARCHIVE'">{{ $t("asset-group-survey.archive") }}</div>
    </nav>

    <div v-if="activeTab === 'IN_PROGRESS'" :class="{ active: activeTab === 'IN_PROGRESS' }" class="mt-4">
      <div v-if="inProgressSurveyPagination">
        <div
          :style="{ backgroundColor: backgroundColors[index % backgroundColors.length] }"
          class="card  p-2 rounded"
          v-for="(item, index) in inProgressSurveyPagination.docs"
          :key="item._id"
        >
          <b-row>
            <b-col md="10">
              <h5>
                {{ item.name | translate }}
              </h5>
            </b-col>
            <b-col md="2">
              <button v-b-tooltip.hover :title="'Anket Katılımcıları'" @click="redirectToMembers(item)" class="btn btn-light btn-sm mr-2 mt-2">
                <i class="mdi mdi-account-group font-size-16"></i>
              </button>
              <button v-b-tooltip.hover :title="'Anket Sonuçları'" @click="redirectToSurveyResults(item)" class="btn btn-light btn-sm mt-2">
                <i class="bx bxs-report font-size-20"></i></button
            ></b-col>
          </b-row>
        </div>
      </div>
      <empty v-if="!inProgressSurveyPagination || inProgressSurveyPagination.docs.length == 0">
        <h5 class="text-center">
          {{ $t("asset-group-survey.empty-in-progress") }}
        </h5>
      </empty>

      <div v-if="inProgressSurveyPagination" class="row">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="inProgressSurveysRequest.options.page"
              :total-rows="inProgressSurveyPagination.totalDocs"
              :per-page="inProgressSurveyPagination.limit"
              limit="10"
              size="sm"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
    <div v-if="activeTab === 'ARCHIVE'" :class="{ active: activeTab === 'ARCHIVE' }" class="mt-4">
      <div v-if="complatedSurveyPagination">
        <div
          :style="{ backgroundColor: backgroundColors[index % backgroundColors.length] }"
          class="card p-2 rounded"
          v-for="(item, index) in complatedSurveyPagination.docs"
          :key="item._id"
        >
          <b-row class="row">
            <b-col md="10" class="">
              <h5>{{ item.name | translate }}</h5>
            </b-col>
            <b-col md="2" class="">
              <button @click="redirectToMembers(item)" class="btn btn-light btn-sm mr-2 mt-2"><i class="mdi mdi-account-group font-size-16"></i></button>
              <button @click="redirectToSurveyResults(item)" class="btn btn-light btn-sm mt-2"><i class="bx bxs-report font-size-20"></i></button>
            </b-col>
          </b-row>
        </div>
      </div>
      <empty v-if="!complatedSurveyPagination || complatedSurveyPagination.docs.length == 0">
        <h5 class="text-center">
          {{ $t("asset-group-survey.empty-in-archived") }}
        </h5>
      </empty>

      <div class="row">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="complatedSurveysRequest.options.page"
              :total-rows="complatedSurveyPagination.totalDocs"
              :per-page="complatedSurveyPagination.limit"
              limit="10"
              size="sm"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationMemberSelect from "@cc/organization-member-select";
export default {
  components: { OrganizationMemberSelect },

  data() {
    return {
      backgroundColors: ["#556ee640", "#34c38f40"],
      activeTab: "IN_PROGRESS",
      inProgressSurveysRequest: {
        options: { page: 1, limit: 15, sort: {} },
        query: {},
      },
      complatedSurveysRequest: {
        options: { page: 1, limit: 15, sort: {} },
        query: {},
      },

      form: {
        id: undefined,
      },
    };
  },
  async mounted() {
    if (this.$route.params.id) {
      await this.fetchInProgressSurveys();
      await this.fetchComplatedSurveys();
    }
  },
  watch: {
    inProgressSurveysRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.fetchInProgressSurveys());
      },
    },
    complatedSurveysRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.fetchComplatedSurveys());
      },
    },
  },
  computed: {
    surveyTemplate() {
      return this.$store.getters[`organizationSurveyTemplate/selectedEntity`];
    },
    inProgressSurveyPagination() {
      return this.$store.getters[`organizationSurvey/inProgressSurveyPagination`];
    },
    complatedSurveyPagination() {
      return this.$store.getters[`organizationSurvey/complatedSurveyPagination`];
    },
  },

  methods: {
    goBack() {
      this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/question-set-survey`);
    },
    redirectToMembers(item) {
      this.$store.commit("organizationSurvey/selectedEntity", item);
      this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/survey/${item._id}/members`);
    },
    redirectToSurveyResults(item) {
      this.$store.commit("organizationSurvey/selectedEntity", item);
      this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/survey/${item._id}/results`);
    },
    async fetchInProgressSurveys() {
      await this.$store.dispatch("organizationSurvey/fetchInProgressSurveys", { pagination: this.inProgressSurveysRequest, templateId: this.$route.params.id });
    },
    async fetchComplatedSurveys() {
      await this.$store.dispatch("organizationSurvey/fetchComplatedSurveys", { pagination: this.inProgressSurveysRequest, templateId: this.$route.params.id });
    },
    onMemberSelected(member) {
      this.form.members.push(member);
    },

    async createSurvey() {
      // const ok = await this.confirm(this.$t("alert.approve"));
      // if (!ok) {
      //   return;
      // }
      try {
        const id = this.$route.params.id;
        this.form.id = id;
        await this.$store.dispatch("organizationSurvey/create", this.form);
        this.$toast.success(this.$t("common.success"));
        this.fetchInProgressSurveys();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async save() {
      const id = this.$route.params.id;
      this.form.id = id;
      await this.$store.dispatch("organizationAssetGroupSurvey/createSurvey", this.form);
      this.$root.$emit("bv::hide::modal", "modal-new-survey");
      this.fetchInProgressSurveys();
    },

    onAccountSelect(members) {
      this.form = { ...this.form, members };
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../entity/organization-entities-view.scss");
</style>
